import * as actionTypes from './actionTypes';

export const getSitesStart = () => {
    return {
        type: actionTypes.GET_SITES_START
    }
}

export const getSites = () => {
    return {
        type: actionTypes.GET_SITES
    }
}

export const getSitesSuccess = (data) => {
    return {
        type: actionTypes.GET_SITES_SUCCESS,
        sites: data.sites
    }
}

export const getSitesFail = (error) => {
    return {
        type: actionTypes.GET_SITES_FAIL,
        error: error
    }
}

export const setFavoriteStart = () => {
    return {
        type: actionTypes.SET_FAVORITE_START
    }
}

export const setFavoriteSite = (sites, siteId) => {
    return {
        type: actionTypes.SET_FAVORITE_SITE,
        sites: sites,
        siteId: siteId
    }
}

export const setFavoriteSuccess = (sites) => {
    return {
        type: actionTypes.SET_FAVORITE_SUCCESS,
        sites: sites
    }
}

export const setFavoriteFail = (error) => {
    return {
        type: actionTypes.SET_FAVORITE_FAIL,
        error: error
    }
}